import gsap from "gsap";
import {ScrollTrigger}from "gsap/ScrollTrigger";
import colors from "../../../../theme/colors";
import typography from "../../../../theme/typography";

gsap.registerPlugin(ScrollTrigger);

export const setupWorkingAnimations=({
  sectionRef,
  visualRef,
  eyebrowRef,
  panelRefs,
  steps
})=>{
  const section=sectionRef.current;
  const visual=visualRef.current;
  const eyebrow=eyebrowRef.current;
  const panels=panelRefs.current;

  if(!section||!visual||!eyebrow||!panels.length)return;

  panels.forEach((panel,index)=>{
    if(index!==0){
      gsap.set(panel,{yPercent:100});
    }
  });

  const pinTrigger=ScrollTrigger.create({
    trigger:section,
    start:"top top",
    end:()=>{
      const content=section.querySelector(".working-content");
      const distance=content
        ?content.offsetHeight-visual.offsetHeight
        :section.offsetHeight-visual.offsetHeight;

      return `+=${Math.max(0,distance)}`;
    },
    pin:visual,
    pinSpacing:false,
    invalidateOnRefresh:true
  });

  const eyebrowTl=gsap.timeline({
    scrollTrigger:{
      trigger:section,
      start:"top 65%",
      end:"top top",
      scrub:1,
      invalidateOnRefresh:true
    }
  });

  eyebrowTl.to(eyebrow,{
    x:()=>{
      const currentVisual=visualRef.current;
      const content=section.querySelector(".working-content");

      if(currentVisual&&content){
        return currentVisual.offsetLeft-content.offsetLeft;
      }

      return -window.innerWidth*0.47;
    },
    duration:0.6,
    ease:"none"
  }).to(eyebrow,{
    fontSize:typography.workingSection.eyebrowActive,
    color:colors.home.navyDeep,
    duration:0.4,
    ease:"power1.out"
  });

  const pinEyebrowTrigger=ScrollTrigger.create({
    trigger:section,
    start:"top top",
    end:()=>{
      const content=section.querySelector(".working-content");
      const distance=content
        ?content.offsetHeight-visual.offsetHeight
        :section.offsetHeight-visual.offsetHeight;

      return `+=${Math.max(0,distance)}`;
    },
    pin:eyebrow,
    pinSpacing:false,
    invalidateOnRefresh:true
  });

  const backgroundTrigger=ScrollTrigger.create({
    trigger:section,
    start:"top 80%",
    end:"top 30%",
    scrub:1,
    onUpdate:self=>{
      const progress=self.progress;

      gsap.set(section,{
        backgroundColor:gsap.utils.interpolate(
          colors.home.navyDeep,
          colors.neutral.white,
          progress
        ),
        color:gsap.utils.interpolate(
          colors.neutral.white,
          colors.home.navyDeep,
          progress
        )
      });

      gsap.set(section.querySelectorAll(".working-number"),{
        color:gsap.utils.interpolate(
          colors.home.textMuted,
          colors.slate[500],
          progress
        )
      });

      gsap.set(
        section.querySelectorAll(
          ".working-heading,.working-title,.working-description"
        ),
        {
          color:gsap.utils.interpolate(
            colors.neutral.white,
            colors.home.navyDeep,
            progress
          )
        }
      );
    }
  });

  const slideTriggers=steps.map((_,index)=>{
    if(index===0)return null;

    return ScrollTrigger.create({
      trigger:`.working-step-${index}`,
      start:"top 55%",
      onEnter:()=>{
        gsap.to(panels[index-1],{
          yPercent:-100,
          duration:0.8,
          ease:"power2.inOut"
        });

        gsap.to(panels[index],{
          yPercent:0,
          duration:0.8,
          ease:"power2.inOut"
        });
      },
      onLeaveBack:()=>{
        gsap.to(panels[index],{
          yPercent:100,
          duration:0.8,
          ease:"power2.inOut"
        });

        gsap.to(panels[index-1],{
          yPercent:0,
          duration:0.8,
          ease:"power2.inOut"
        });
      }
    });
  });

  const refreshId=requestAnimationFrame(()=>{
    ScrollTrigger.refresh();
  });

  return()=>{
    cancelAnimationFrame(refreshId);
    pinTrigger.kill();
    pinEyebrowTrigger.kill();
    eyebrowTl.kill();
    backgroundTrigger.kill();

    slideTriggers.forEach(trigger=>{
      trigger?.kill();
    });
  };
};